import styled, { keyframes } from 'styled-components'
import { Link } from 'react-router-dom'

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

const pulse = keyframes`
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
`

const float = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
`

export const Container = styled.main`
  min-height: calc(100vh - 52px);
  animation: ${fadeIn} 0.6s ease-out;
  background: ${({ theme }) => theme.colors.background};
`

export const ErrorSection = styled.section`
  padding: 80px 20px;
  background: ${({ theme }) => theme.colors.heroGradient};
  color: white;
  animation: ${fadeIn} 0.8s ease-out;
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;

  .error-content {
    max-width: 800px;
    text-align: center;
    animation: ${fadeInUp} 0.8s ease-out 0.2s both;
  }
`

export const ErrorCode = styled.div`
  font-size: 10rem;
  font-weight: 900;
  color: white;
  margin-bottom: 20px;
  animation: ${float} 3s ease-in-out infinite;
  text-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  line-height: 1;

  @media (max-width: 720px) {
    font-size: 6rem;
  }
`

export const ErrorMessage = styled.div`
  margin-bottom: 40px;

  h1 {
    font-size: 2.5rem;
    margin-bottom: 15px;
    color: white;

    @media (max-width: 720px) {
      font-size: 2rem;
    }
  }

  .subtitle {
    font-size: 1.3rem;
    margin-bottom: 20px;
    opacity: 0.95;
    font-weight: 500;
    color: white;

    @media (max-width: 720px) {
      font-size: 1.1rem;
    }
  }

  p {
    font-size: 1.1rem;
    line-height: 1.6;
    opacity: 0.9;
    color: white;

    @media (max-width: 720px) {
      font-size: 1rem;
    }
  }
`

export const CTAButton = styled(Link)`
  display: inline-block;
  padding: 15px 40px;
  background: white;
  color: ${({ theme }) => theme.colors.primary};
  border-radius: 8px;
  font-weight: 600;
  font-size: 1.1rem;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
    animation: ${pulse} 0.5s ease;
  }

  @media (max-width: 720px) {
    font-size: 1rem;
    padding: 12px 30px;
  }
`

export const QuickLinksSection = styled.section`
  padding: 60px 20px;
  max-width: 1200px;
  margin: 0 auto;
  animation: ${fadeInUp} 0.8s ease-out 0.4s both;

  h2 {
    font-size: 2rem;
    text-align: center;
    margin-bottom: 15px;
    color: ${({ theme }) => theme.colors.text};

    @media (max-width: 720px) {
      font-size: 1.5rem;
    }
  }

  .section-description {
    text-align: center;
    font-size: 1.1rem;
    color: ${({ theme }) => theme.colors.textSecondary};
    margin-bottom: 40px;

    @media (max-width: 720px) {
      font-size: 1rem;
    }
  }

  .quick-links-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;
    margin-top: 30px;

    @media (max-width: 720px) {
      grid-template-columns: 1fr;
      gap: 15px;
    }
  }
`

export const QuickLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: ${({ theme }) => theme.colors.cardBackground};
  border: 2px solid ${({ theme }) => theme.colors.border};
  border-radius: 8px;
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: none;
  font-weight: 600;
  font-size: 1rem;
  transition: all 0.3s ease;
  text-align: center;

  &:hover {
    background: ${({ theme }) => theme.colors.primary};
    color: white;
    border-color: ${({ theme }) => theme.colors.primary};
    transform: translateY(-3px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }

  @media (max-width: 720px) {
    padding: 15px;
    font-size: 0.95rem;
  }
`
